import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {of} from 'rxjs/internal/observable/of';
import {Subscription} from 'rxjs/internal/Subscription';
import {mergeMap, shareReplay, map} from 'rxjs/operators';
import {UserService} from '../../../shared/services/user/user.service';
import {NotificationService} from '../../v2-node-api/services/notification.service';
import {Notification, NotificationBase, NotificationAuthorityType} from '../interfaces/notification-base.interface';
import {NotificationWithSoundAlerts} from '../interfaces/notify-with-sound.interface';

import {NotificationsConfigurationService} from './notifications-configuration.service';
import { WorkflowSocketServiceService } from './workflow-socket-service.service';
import { WorkflowContentInterface } from '../interfaces/workflow-content.interface';
import { TasksService } from 'src/app/+home/+dashboard/tasks.service';
import { fromPromise } from 'rxjs/internal-compatibility';


@Injectable({
  providedIn: 'root'
})
export class WorkflowNotificationService extends NotificationWithSoundAlerts{
  protected onAnswerSubscription: Subscription = null;
  //public content:ExportContentInterface;
  constructor(
    protected notificationsSocketService: WorkflowSocketServiceService,
    protected userService: UserService,
    protected notificationService: NotificationService,
    private taskService:TasksService
  ) { 
    super('workflow', notificationsSocketService);
    this.soundPath = '../assets/audio/alert2.mp3';
    this.join();
    this.configuration = new NotificationsConfigurationService();
    this.configuration.getSound$().subscribe(on => {
      if (on) {
        this.subscribeToSoundAlert();
      } else {
        this.unsubscribeToSoundAlert();
      }
    });
    
  }
  fromAlertToNotification(alert): NotificationBase {
    const workflowContent: WorkflowContentInterface = {
      type: alert.entry.type,
      id:alert.entry.id,
      processId:alert.entry.processId,
      name:alert.entry.name,
      nodeRef:alert.nodeRef,
      authorities: alert.entry.assignee,
      fileName: alert.title,
      //seen: false,
    };
    return {
      domain: 'workflow',
      content: workflowContent,
      authorities: [{
        type: NotificationAuthorityType.Single,
        value: workflowContent.authorities
      }],
      action: 'create',
      createdAt: null,
      metadata: null
    };
  }
 

  public undonetasks() {
    
    return fromPromise(this.taskService.getCurrentTasks(0,10)).pipe(
      shareReplay(),
      mergeMap((value: any) => {
      
        return of(...value.list.entries);
      }),
      map(this.fromAlertToNotification)
    );
  }
  initNotifications(): Observable<Notification> {
    return this.undonetasks();

  }





  join(): void {
    this.notificationSocket.on('connect', () => {
      this.userService.getCurrentUser().then(user => {
        this.notificationSocket.emit('join', user);
      });
    });
  }

  
  
}
